import React, { useMemo, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import { Stack, Chip } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import OverviewDialog from './OverviewDialog';
import UserAvatar from '../../../common/UserAvatar';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';

const ShabashNominations = ({ data }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedNomination, setSelectedNomination] = useState(null);

  const handleOpenDialog = (nomination) => {
    setSelectedNomination(nomination);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedNomination(null);
    setOpenDialog(false);
  };

  const columns = [
    {
      name: 'index',
      label: 'No',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => <span>{tableMeta.rowIndex + 1}</span>,
      },
    },
    {
      name: 'employeeName',
      label: 'Employee Name',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const row = tableMeta.rowData;
          const photo = row[3];
          return (
            <Stack direction={'row'} alignItems={'center'}>
              <UserAvatar src={photo} />
              <Box sx={{ ml: 2 }}>
                <Typography
                  noWrap
                  fontSize={'16px'}
                  sx={{
                    display: 'flex',
                    maxWidth: '200px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {value}
                </Typography>
              </Box>
            </Stack>
          );
        },
      },
    },
    {
      name: 'nominatedBy',
      label: 'Nominated By',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'photo',
      label: 'Photo',
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dateNominated',
      label: 'Date Nominated',
      options: {
        filter: true,
        filterOptions: { fullWidth: true },
        sort: true,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        filterOptions: { fullWidth: true },
        sort: false,
        customBodyRender: (value) => (
          <Stack direction={'row'}>
            <Chip
              style={{
                backgroundColor:
                  value === 'Pending'
                    ? 'rgba(255, 193, 7, 0.16)'
                    : value === 'Approved'
                    ? 'rgba(84, 214, 44, 0.16)'
                    : value === 'Rejected'
                    ? 'rgba(255, 72, 66, 0.16)'
                    : 'black',
                color:
                  value === 'Pending'
                    ? '#B78103'
                    : value === 'Approved'
                    ? '#229A16'
                    : value === 'Rejected'
                    ? 'red'
                    : 'black',
                borderRadius: '6px',
                width: '5.5rem',
                fontWeight: 'bold',
              }}
              label={value}
            />
          </Stack>
        ),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <Stack spacing={2} direction={'row'}>
            <Visibility
              onClick={() => handleOpenDialog(tableData[tableMeta.rowIndex])}
              sx={{ cursor: 'default' }}
              aria-label="view"
            />
            {/* Add other actions here if needed */}
          </Stack>
        ),
      },
    },
  ];
  const tableData = useMemo(() => {
    let formattedData =
      data?.map((nomination) => ({
        _id: nomination._id,
        employeeName: nomination.nominee.userName || 'N/A',
        nominatedBy: nomination.nominator.userName || 'N/A',
        dateNominated: new Date(nomination.dateNominated).toLocaleDateString(),
        rawDateNominated: new Date(nomination.dateNominated),
        status: nomination.status,
        actions: nomination._id,
        photo: nomination.nominee.employeePhotoPath,
        nominationReason: nomination.nominationReason,
        attachment: nomination.attachment,
      })) || [];
    formattedData.sort((a, b) => new Date(b.rawDateNominated) - new Date(a.rawDateNominated));
    return formattedData;
  }, [data]);

  const tableBodyMaxHeight = useMemo(() => {
    const rowsPerPage = 20;
    const rowHeight = 29;
    const headerHeight = 48;
    const paginationHeight = 56;

    return rowsPerPage * rowHeight + headerHeight + paginationHeight + 'px';
  }, []);

  return (
    <>
      <MUIDataTable
        title={
          <Typography fontSize={'16px'} fontWeight={'bold'}>
            Shabash Details
          </Typography>
        }
        data={tableData}
        columns={columns}
        options={{
          selectableRows: false,
          rowsPerPage: 20,
          rowsPerPageOptions: [20, 30, 40],
          viewColumns: false,
          search: true,
          searchOpen: false,
          download: false,
          filter: true,
          print: false,
          tableBodyMaxHeight: '73vh',
        }}
        className="custom-mui-datatable"
      />
      <style>
        {`
          .custom-mui-datatable {
            background-color: transparent !important;
            box-shadow: none !important;
          }
        `}
      </style>
      <OverviewDialog handleCloseDialog={handleCloseDialog} open={openDialog} selectedNomination={selectedNomination} />
    </>
  );
};

export default ShabashNominations;
